import { render, staticRenderFns } from "./PerfilAluno.vue?vue&type=template&id=054493a8&scoped=true&"
import script from "./PerfilAluno.vue?vue&type=script&lang=js&"
export * from "./PerfilAluno.vue?vue&type=script&lang=js&"
import style0 from "./PerfilAluno.vue?vue&type=style&index=0&id=054493a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054493a8",
  null
  
)

export default component.exports